import * as TabsPrimitive from '@radix-ui/react-tabs';
import { forwardRef, type ComponentPropsWithoutRef, type ElementRef } from 'react';
import { cn } from './cn';

export const Tabs = TabsPrimitive.Root;

export const TabsList = forwardRef<
  ElementRef<typeof TabsPrimitive.List>,
  ComponentPropsWithoutRef<typeof TabsPrimitive.List>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.List
    ref={ref}
    className={cn(
      'inline-flex h-9 items-center justify-center gap-0.5 rounded-[var(--radius-md)] p-0.5',
      className,
    )}
    style={{ background: 'var(--surface-1)', color: 'var(--content-muted)' }}
    {...props}
  />
));
TabsList.displayName = TabsPrimitive.List.displayName;

export const TabsTrigger = forwardRef<
  ElementRef<typeof TabsPrimitive.Trigger>,
  ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Trigger
    ref={ref}
    className={cn(
      'inline-flex items-center justify-center whitespace-nowrap rounded-[var(--radius-sm)] px-3 py-1 text-[13px] font-medium',
      'transition-all focus-visible:outline-none focus-visible:[box-shadow:var(--focus-ring-brand)]',
      'disabled:pointer-events-none disabled:opacity-50',
      // 기본 색을 inline style 로 주면 data-[state=active] 클래스가 항상 inline 에 져서
      // active 색이 죽는다(스위치 --surface-3 류 버그) → 반드시 className 으로.
      'text-[var(--content-muted)]',
      // active = 브랜드 red 액센트 (sidebar active 와 동일 계열 — 시스템 외 indigo 제거).
      'data-[state=active]:shadow-[var(--elevation-1)] data-[state=active]:text-[var(--accent-default)] data-[state=active]:bg-[var(--accent-soft)]',
      className,
    )}
    {...props}
  />
));
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName;

export const TabsContent = forwardRef<
  ElementRef<typeof TabsPrimitive.Content>,
  ComponentPropsWithoutRef<typeof TabsPrimitive.Content>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Content
    ref={ref}
    className={cn(
      'mt-2 focus-visible:outline-none focus-visible:[box-shadow:var(--focus-ring-brand)]',
      className,
    )}
    {...props}
  />
));
TabsContent.displayName = TabsPrimitive.Content.displayName;
